import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import events1 from "../../assets/Images/events-pics/events1.jpg";
import events2 from "../../assets/Images/events-pics/events2.jpg";
import events3 from "../../assets/Images/events-pics/events3.jpg";
import events4 from "../../assets/Images/events-pics/events4.jpg";

import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



const Lo5Job = () => {
    const navigate = useNavigate();

    const images = [events1, events2, events3, events4];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Exploration of Job Vacancies</h1>
                <p>Throughout this semester I have to try to explore what kind of job i would like to do</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                                <BreadcrumbHeader />
                        </div>
            <div className="content-lo5">
                <div className="content-lo5-job">
                    <div className="content-lo5-job-text">
                        <h1>Career Day</h1>
                        <p>
                            During the Career Day, I visited several job stands to learn more about the types
                            of roles available for ICT Media Students. Doing this gave me a clearer idea of what
                            kind of fields that interested me and I could try to build experience connecting with
                            the roles/ fields I am trying to pursue.
                        </p>
                        <h1>LinkedIn Profile</h1>
                        <p>
                            To support my job search, I also tried to create a LinkedIn Profile, although it's still
                            work in progress, it is the beginning of building my professional online and connecting 
                            with opportunities in the ICT field.
                        </p>

                        
                    </div>

                    <div className="content-lo5-job-slideshow">
                        <Slideshow images={images} />

                    </div>
                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo5Job;